import "./EditUsers.scss";
import "../../styles/CalendarStyles.css";

import chevronLeft from "../../assets/images/icons/chevron-left.svg";
import chevronDown from "../../assets/images/icons/chevron-down.svg";
import bin from "../../assets/images/icons/delete.svg";
import checkMark from "../../assets/images/icons/check-mark.svg";
import calendar from "../../assets/images/icons/calendar.svg";

import { Link, useParams, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import Dropdown from "../../components/Dropdown/Dropdown";

import axios from "axios";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import Calendar from "react-calendar";
import TopNav from "../../components/TopNav/TopNav";
import SideBar from "../../components/SideBar/SideBar";

function EditUsers() {
    const { userID } = useParams();
    const navigate = useNavigate();

    //FIND USER =================================================================

    const [curUser, setCurUser] = useState({});

    useEffect(() => {
        const getUser = async () => {
            try {
                const response = await axios.get(`https://zona-app-server-584d567d8841.herokuapp.com/users/${userID}`);
                setCurUser(response.data);
            } catch (err) {
                console.log(`error retrieving user. this is the error: ${err}`);
            }
        };

        getUser();
    }, [userID]);

    //FORM ONCHANGES ============================================================

    const [newFirstName, setNewFirstName] = useState("");
    const [newLastName, setNewLastName] = useState("");
    const [newBday, setNewBday] = useState("");
    const [newLocation, setNewLocation] = useState("");
    // const [newGender, setNewGender] = useState('');
    const [newEmail, setNewEmail] = useState("");
    const [newPhone, setNewPhone] = useState("");
    const [newIg, setNewIg] = useState("");

    async function handleFormSubmit(event) {
        event.preventDefault();

        const editedUser = {
            firstName: newFirstName,
            lastName: newLastName,
            bday: formatDate(newBday),
            location: newLocation,
            gender: dropdownSelectGender,
            email: newEmail,
            phone: newPhone,
            ig: newIg,
        };

        try {
            await axios.put(`https://zona-app-server-584d567d8841.herokuapp.com/users/${curUser.id}`, editedUser);
            navigate("/users");
        } catch (err) {
            console.log(`error updating user. this was the error: ${err}`);
        }
    }

    //HANDLE CALENDAR ============================================================

    // const [birthday, setBirthday] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);

    // Format the selected date to DD/MM/YYYY
    const formatDate = (date) => {
        if (!date) return "";

        const d = new Date(date),
            day = "" + d.getDate(),
            month = "" + (d.getMonth() + 1),
            year = d.getFullYear();

        return [day.padStart(2, "0"), month.padStart(2, "0"), year].join("/");
    };

    const handleDateChange = (nextValue) => {
        setNewBday(nextValue);
        setShowCalendar(false); // Hide the calendar after a date is selected
    };

    //DROPDOWN ==================================================================

    const [showDropdown, setShowDropdown] = useState(false);
    const [dropdownSelectGender, setDropdownSelectGender] = useState(curUser?.gender);

    const componentRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (componentRef.current && !componentRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    //DELETE MODAL =============================================================

    const [deleteModal, setDeleteModal] = useState(false);
    const [userToDelete, setUserToDelete] = useState({});

    function handleDeleteUser(user) {
        setDeleteModal(true);
        setUserToDelete(user);
    }

    function handleDelete(id) {
        const deleteUser = async () => {
            try {
                await axios.delete(`https://zona-app-server-584d567d8841.herokuapp.com/users/${id}`);
                setDeleteModal(false);
                navigate("/users");
            } catch (err) {
                console.log(`failed to delete user. this is the error: ${err}`);
            }
        };

        deleteUser();
    }

    return (
        <main>
            <TopNav />
            <div className="main-container">
                <SideBar />
                {deleteModal && (
                    <DeleteModal
                        handleDelete={handleDelete}
                        setDeleteModal={setDeleteModal}
                        modToDelete={userToDelete}
                        tableName={"Users"}
                    />
                )}
                <article style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <section className="edit-user">
                        <div className="edit-user__top">
                            <div className="edit-user__top-left">
                                <Link to="/users">
                                    <img
                                        className="edit-user__top-left-icon"
                                        src={chevronLeft}
                                        alt="Left pointing chevron"
                                    ></img>
                                </Link>
                                <h1 className="edit-user__top-left-heading">Editing User</h1>
                            </div>
                            <button className="edit-user__top-button" onClick={() => handleDeleteUser(curUser)}>
                                <p className="edit-user__top-button-text">Delete User</p>
                                <img src={bin} alt="icon of garbage bin"></img>
                            </button>
                        </div>

                        <form onSubmit={handleFormSubmit} className="edit-user__form">
                            <div className="edit-user__form-first">
                                <div className="edit-user__form-first-field">
                                    <label htmlFor="userFirstName" className="edit-user__form-first-field-label">
                                        First name
                                    </label>
                                    <input
                                        type="text"
                                        id="userFirstName"
                                        value={newFirstName}
                                        onChange={(event) => setNewFirstName(event.target.value)}
                                        name="firstName"
                                        placeholder={curUser?.firstName}
                                        className="edit-user__form-first-field-input"
                                    />
                                </div>

                                <div className="edit-user__form-first-field">
                                    <label htmlFor="userLastName" className="edit-user__form-first-field-label">
                                        Last name
                                    </label>
                                    <input
                                        type="text"
                                        id="userLastName"
                                        value={newLastName}
                                        onChange={(event) => setNewLastName(event.target.value)}
                                        name="lastName"
                                        placeholder={curUser?.lastName}
                                        className="edit-user__form-first-field-input"
                                    />
                                </div>
                            </div>

                            <div className="edit-user__form-first">
                                <div className="edit-user__form-first-field">
                                    <label htmlFor="birthDay" className="edit-user__form-first-field-label">
                                        Birthday
                                    </label>
                                    <div className="edit-user__form-first-field-container">
                                        <input
                                            type="text"
                                            id="birthDay"
                                            name="bday"
                                            placeholder={curUser?.bday ? curUser?.bday : "DD/MM/YYYY"}
                                            className="edit-user__form-first-field-input"
                                            value={newBday ? formatDate(newBday) : ""}
                                            onChange={(event) => setNewBday(event.target.value)}
                                            onFocus={() => setShowCalendar(true)}
                                        />
                                        <img
                                            src={calendar}
                                            alt="calendar button"
                                            className="edit-user__form-first-field-input--calendar"
                                            onClick={() => setShowCalendar(true)}
                                        />
                                    </div>
                                    <div className="edit-user__form-first-field-input-calendar">
                                        {showCalendar && (
                                            <Calendar
                                                onChange={handleDateChange}
                                                value={newBday}
                                                next2Label={null}
                                                prev2Label={null}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="edit-user__form-first-field">
                                    <label htmlFor="location" className="edit-user__form-first-field-label">
                                        Location
                                    </label>
                                    <input
                                        className="edit-user__form-first-field-input"
                                        id="location"
                                        name="location"
                                        type="text"
                                        value={newLocation}
                                        onChange={(event) => setNewLocation(event.target.value)}
                                        placeholder={curUser?.location}
                                    ></input>
                                </div>
                            </div>

                            <div className="edit-user__form-first">
                                <div className="edit-user__form-first-field">
                                    <p className="edit-user__form-first-field-label">Gender</p>
                                    <div ref={componentRef}>
                                        <div
                                            onClick={() => setShowDropdown(!showDropdown)}
                                            className="edit-user__form-first-field-input edit-user__form-first-field-input--dropdown"
                                        >
                                            <p>{dropdownSelectGender ? dropdownSelectGender : curUser?.gender}</p>
                                            <img src={chevronDown} alt="chevron pointing down"></img>
                                        </div>
                                        {showDropdown && (
                                            <Dropdown
                                                type={"radio"}
                                                data={["Female", "Male", "Non-binary", "Prefer not to answer"]}
                                                setter={setDropdownSelectGender}
                                                valueSet={dropdownSelectGender}
                                            />
                                        )}
                                    </div>
                                </div>

                                <div className="edit-user__form-first-field">
                                    <label htmlFor="email" className="edit-user__form-first-field-label">
                                        E-mail
                                    </label>
                                    <input
                                        className="edit-user__form-first-field-input"
                                        id="email"
                                        name="email"
                                        type="email"
                                        value={newEmail}
                                        onChange={(event) => setNewEmail(event.target.value)}
                                        placeholder={curUser?.email || "-"}
                                    ></input>
                                </div>
                            </div>

                            <div className="edit-user__form-first">
                                <div className="edit-user__form-first-field">
                                    <label htmlFor="phoneNum" className="edit-user__form-first-field-label">
                                        Phone
                                    </label>
                                    <input
                                        className="edit-user__form-first-field-input"
                                        id="phoneNum"
                                        name="phoneNum"
                                        type="text"
                                        value={newPhone}
                                        onChange={(event) => setNewPhone(event.target.value)}
                                        placeholder={curUser?.phone || "-"}
                                    ></input>
                                </div>
                                <div className="edit-user__form-first-field">
                                    <label htmlFor="igTag" className="edit-user__form-first-field-label">
                                        Instagram
                                    </label>
                                    <input
                                        className="edit-user__form-first-field-input"
                                        id="igTag"
                                        name="igTag"
                                        type="text"
                                        value={newIg}
                                        onChange={(event) => setNewIg(event.target.value)}
                                        placeholder={curUser?.ig || "-"}
                                    ></input>
                                </div>
                            </div>

                            <button type="submit" className="edit-user__form-button">
                                <p className="edit-user__form-button-text">Update Information</p>
                                <img src={checkMark} alt="a checkmark"></img>
                            </button>
                        </form>
                    </section>
                </article>
            </div>
        </main>
    );
}

export default EditUsers;
